export interface Origin {
  id: string
  type: OriginType
}

export enum OriginType {
  Device = 'device',
  GearRule = 'gear_rule',
  Job = 'job',
  System = 'system',
  Unknown = 'unknown',
  User = 'user',
}
